// hooks/useCustomers.js
import { useState, useEffect, useCallback } from 'react';
import { customerApi } from '../api/customers';
import toast from 'react-hot-toast';

export const useCustomers = () => {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchCustomers = useCallback(async () => {
    setLoading(true);
    try {
      const response = await customerApi.getAll();
      setCustomers(response.data);
      setError(null);
    } catch (err) {
      setError(err.message);
      toast.error('Failed to fetch customers');
    } finally {
      setLoading(false);
    }
  }, []);

  const addCustomer = useCallback(async (data) => {
    try {
      const response = await customerApi.create(data);
      toast.success('Customer added successfully!');
      await fetchCustomers();
      return response.data;
    } catch (err) {
      toast.error(err.response?.data?.error || 'Failed to add customer');
      throw err;
    }
  }, [fetchCustomers]);

  const updateCustomer = useCallback(async (id, data) => {
    try {
      const response = await customerApi.update(id, data);
      toast.success('Customer updated successfully!');
      await fetchCustomers();
      return response.data;
    } catch (err) {
      toast.error(err.response?.data?.error || 'Failed to update customer');
      throw err;
    }
  }, [fetchCustomers]);

  const deleteCustomer = useCallback(async (id) => {
    try {
      await customerApi.delete(id);
      toast.success('Customer deleted successfully!');
      await fetchCustomers();
    } catch (err) {
      toast.error(err.response?.data?.error || 'Failed to delete customer');
      throw err;
    }
  }, [fetchCustomers]);

  const searchCustomers = useCallback(async (query) => {
    try {
      const response = await customerApi.search(query);
      return response.data;
    } catch (err) {
      toast.error('Failed to search customers');
      throw err;
    }
  }, []);

  useEffect(() => {
    fetchCustomers();
  }, [fetchCustomers]);

  return { 
    customers, 
    loading, 
    error, 
    fetchCustomers, 
    addCustomer, 
    updateCustomer, 
    deleteCustomer,
    searchCustomers
  };
};